import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { INNER_BOTTOM_SPACE_DESK, colorsPalette } from '../../theme';
import mapImg from '../../assets/images/map.jpg';

const useStyles = (background) =>
  makeStyles((theme: Theme) =>
    createStyles({
      wrapper: {
        paddingTop: 36,
        paddingBottom: 36,
        background: theme.palette.secondary.dark,
        overflowX: 'hidden',
        '&:first-child': {
          marginTop: 76,
        },

        [theme.breakpoints.up('sm')]: {
          paddingTop: 72,
          paddingBottom: 72,
          background:
            background === 'Dark' ? theme.palette.secondary.dark : theme.palette.secondary.light,

          '&:first-child': {
            marginTop: 120,
          },
        },
      },
      container: {},
      heading: {
        [theme.breakpoints.up('sm')]: {
          display: 'none',
        },
      },
      desktopHeading: {
        display: 'none',
        [theme.breakpoints.up('sm')]: {
          display: 'block',
          marginBottom: INNER_BOTTOM_SPACE_DESK,
        },
      },
      content: {
        display: 'flex',
        flexDirection: 'column-reverse',
        [theme.breakpoints.up('sm')]: {
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          flexDirection: 'row',
        },
      },
      contactForm: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        [theme.breakpoints.up('sm')]: {
          width: 'calc(50% - 15px)',
          alignItems: 'flex-start',
        },
      },
      contactFormFieldWrap: {
        marginBottom: 24,
        width: '100%',

        [theme.breakpoints.up('sm')]: {
          marginBottom: 31,
        },
      },
      contactFormField: {
        width: '100%',
      },
      errorMsg: {
        display: 'block',
        marginTop: 6,
        paddingLeft: 8,
        color: colorsPalette.red,
      },
      contactFormButton: {
        marginTop: 36,
      },
      contactMap: {
        display: 'block',
        width: '100%',
        height: 258,
        borderRadius: 5,
        overflow: 'hidden',
        background: `url(${mapImg})`,
        backgroundSize: 'cover',
        marginBottom: 35,
        [theme.breakpoints.up('sm')]: {
          width: 'calc(50% - 15px)',
          height: 448,
          marginBottom: 0,
          backgroundPositionY: '-1px',
        },
      },
      menu: {},
      popover: {
        fontSize: 16,
        width: 300,
        marginLeft: 15,
        color: colorsPalette.gray,
        background: theme.palette.secondary.light,

        [theme.breakpoints.up('sm')]: {
          width: 500,
        },
      },
    }),
  );
export default useStyles;
